/* eslint-disable import/no-cycle */
import axios from 'axios'
import store from '../utils/store'
import {
  API_CANCEL_ORDER,
  API_DELETE_OPTION,
  API_DELETE_PRODUCT,
  API_GENERATE_ACCESS_TOKEN_HUBRISE,
  API_GET_BILLING_SHOP,
  API_GET_COMPLETED_ORDERS,
  API_GET_CUSTOMER_ORDERS,
  API_GET_SALES_SHOP,
  API_PREPARE_ORDER,
  API_REFUND_PAYMENT,
  API_SYNCHRONIZE_MENU_HUBRISE,
  API_UPDATE_OPTION,
  API_UPDATE_PRODUCT,
  API_UPDATE_SECTION,
  API_UPLOAD_IMAGE,
  API_VALIDATE_ORDER,
  API_LUNCH_DELIVERY,
  API_ACCEPT_DELIVERY,
  API_READY_TO_TAKEAWAY,
  API_NOTIFICATION,
  API_UPDATE_NOTIFICATION
} from '../constants'
import { getIdToken, getFirebaseCustomerId } from './firebase'
import { removeEmptyStringFromObjectValues } from '../utils/tools'
import moment from 'moment';
import { sendCloudWatchAlert } from '../utils/applicationError';
export const initializeBackend = domain => {
  // domain = 'https://dishop-dev-backend.ngrok.io'
  axios.defaults.baseURL = String(domain);
  return true;
};

export const sendGetRequest = async (url, data, headers, addCompanyIdToBody = true) => {
  try {
    const { companyId } = store.getState().user;
    const newData = addCompanyIdToBody
      ? { ...data, companyId }
      : data;
    const response = await axios({
      method: 'get',
      url,
      params: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? error.response.data.errorMessage : error;
    throw errorMessage;
  }
};

export const sendDeleteRequest = async (url, data, headers) => {
  try {
    const { companyId } = store.getState().user;
    const newData = { ...data, companyId };
    const response = await axios({
      method: 'delete',
      url,
      data: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? error.response.data.errorMessage : error;
    throw errorMessage;
  }
};

export const sendPostRequest = async (url, data, headers, compId, addCompanyIdToBody = true) => {
  let companyId = '';
  try {
    if (addCompanyIdToBody) {
      if (!compId) {
        companyId = store.getState().user.companyId;
      } else {
        companyId = compId;
      }
    }
    const newData = addCompanyIdToBody
      ? { ...data, companyId }
      : data;
    if (addCompanyIdToBody && compId === '') {
      delete newData.companyId
    }
    return axios({
      method: 'post',
      url,
      data: newData,
      headers
    });
  } catch (error) {
    throw error.response ? `${error.response.data.errorMessage}` : error;
  }
};

export const sendPutRequest = async (url, data, headers, compId) => {
  let companyId = '';
  try {
    if (!compId) {
      companyId = store.getState().user.companyId;
    } else {
      companyId = compId;
    }
    const newData = { ...data, companyId };
    if (compId === '') delete newData.companyId
    const response = await axios({
      method: 'put',
      url,
      data: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? `${error.response.data.errorMessage}` : error;
    throw errorMessage;
  }
};
export const generateHubriseAccess = async authorizationCode => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_GENERATE_ACCESS_TOKEN_HUBRISE,
    { shopId, authorizationCode },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const updateProduct = async (product, section, synchronize, shops) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;

  delete product.hidden // FIX when hidden = true disabled fields are forced to true in backend which leads to undesired behavior

  await sendPostRequest(
    API_UPDATE_PRODUCT,
    { shopId, section, product, synchronize, shops },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const deleteProduct = async (key, sectionKey, synchronize, shops) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const { data } = await sendPostRequest(
    API_DELETE_PRODUCT,
    { shopId, sectionKey, key, keepSection: true, synchronize, shops },
    { Authorization: `Bearer ${idToken}` }
  );
  return data;
};
export const updateSection = async (section, synchronize, shops) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_UPDATE_SECTION,
    { shopId, section, synchronize, shops },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const synchronizeMenuHubrise = async () => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_SYNCHRONIZE_MENU_HUBRISE,
    { shopId, replace: true },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const updateOptionCategory = async (optionCategory, synchronize, shops, newItem) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  let category = { ...optionCategory };
  category = removeEmptyStringFromObjectValues(category);

  await sendPostRequest(
    API_UPDATE_OPTION,
    {
      shopId,
      option: category,
      synchronize,
      shops,
      newItem
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const deleteOptionCategory = async (categoryKey, synchronize, shops, optionKey) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_DELETE_OPTION,
    {
      shopId,
      key: categoryKey,
      optionKey,
      synchronize,
      keepCategory: true,
      shops
    },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const uploadImage = async image64 => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const { data = '' } = await sendPostRequest(
    API_UPLOAD_IMAGE,
    {
      shopId,
      image64
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return data;
};

export const mooveOrderToCook = async (order, preparationTime) => {
  const idToken = await getIdToken();
  await sendPostRequest(
    API_PREPARE_ORDER,
    {
      customerId: order.id,
      preparationTime,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const mooveOrderToTakeAway = async order => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_READY_TO_TAKEAWAY(companyId, order?.chargeId, order?.id),
    {

    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const mooveOrderToCancel = async (order, cancelReason) => {
  const idToken = await getIdToken();
  const cancellation = {
    canceledBy: 'shop',
    cancelReason,
    chargeId: order.chargeId
  };
  await sendPostRequest(
    API_CANCEL_ORDER,
    {
      customerId: order.id,
      cancellation,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const refundOrder = async (order, isPastOrder) => {
  const { shopId, id: customerId, chargeId } = order;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_REFUND_PAYMENT,
    {
      shopId,
      customerId,
      chargeId,
      isPastOrder
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const mooveOrderToPastOrder = async order => {
  const idToken = await getIdToken();
  await sendPostRequest(
    API_VALIDATE_ORDER,
    {
      customerId: order.id,
      validatedBy: 'shop',
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const getCustomerOrders = async customerId => {
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    API_GET_CUSTOMER_ORDERS,
    {
      customerId
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getSales = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    API_GET_SALES_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getBilling = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken()
  const response = await sendPostRequest(
    API_GET_BILLING_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getCompletedOrders = async (shopId, orderBy, equalTo, startAt, endAt) => {
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    API_GET_COMPLETED_ORDERS,
    {
      shopId,
      orderBy,
      equalTo,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};
export const menuSynchronisation = async (resetMenu, updatePaymentTypes) => {
  const { shopId, companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/shops/${shopId}/menu/synchronization`,
    {
      updatePaymentTypes,
      resetMenu
    },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const getAllDrivers = async (isFreelance) => {
  const { shopId, companyId } = store.getState().user;
  if (shopId && getFirebaseCustomerId()) {
    const idToken = await getIdToken();
    const response = await sendGetRequest(
      `/api/${companyId}/shops/${shopId}/drivers`,
      {
        isFreelance
      },
      { Authorization: `Bearer ${idToken}` }
    );
    return response.data;
  }

};
export const updateManagementFee = async (managementFee) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(

    `/api/${companyId}/configuration/management-fees`,

    managementFee
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};

export const getLoyaltyPrograms = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    `/api/${companyId}/loyalty-programs`,
    {},
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};
export const updateLoyaltyConfiguration = async (configuration) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/configuration/loyalty`,

    configuration
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addLoyaltyVersion = async (versionName, minBasket, defaultVersion) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const updateLoyaltyVersion = async (versionName, minBasket, defaultVersion, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPutRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/configuration`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const deleteLoyaltyVersion = async (key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendDeleteRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}`,
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addVersionShops = async (shopIds, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/shops`,

    { shopIds }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addOfferedProducts = async (program, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  return sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/products`,
    program,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false
  );

};
export const getDeepLinks = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    `/api/${companyId}/deeplinks`,
    {},
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;

};
export const addNewDeepLink = async (campaign, channel) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  return sendPostRequest(
    `/api/${companyId}/deeplinks`,
    { campaign, channel },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false
  );

};

export const getDeepLinksAnalytics = async (campaign, channel, startDate, endDate, creationDate) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();

  const todayMinus2Days = moment().subtract(2, 'days');

  endDate = moment(endDate).isAfter(todayMinus2Days) ? todayMinus2Days : moment(endDate);

  if (!creationDate || !creationDate && endDate.isAfter(todayMinus2Days)) {
    startDate = moment(startDate).subtract(2, 'days');
  }

  const params = new URLSearchParams({
    campaign,
    channel,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    isRealTime: false
  }).toString();

  try {
    const response = await sendGetRequest(
      `/api/${companyId}/deeplinks/analytics?${params}`,
      null,
      {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      false
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des données d'analyse:", error);
    throw error;
  }
};

export const lunchDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_LUNCH_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const acceptDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_ACCEPT_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const pushNotification = async ({ title, message, scheduledDate, toAllUsers }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPostRequest(
      API_NOTIFICATION(companyId),
      {
        toAllUsers,
        shopId: toAllUsers ? null : shopId,
        title,
        message,
        scheduledDate
      },
      { Authorization: `Bearer ${idToken}` }
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in pushNotification: ${err}`);
  }
}
export const updatePushNotification = async ({ title, message, scheduledDate, toAllUsers, id }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_NOTIFICATION(companyId, id),
      {
        toAllUsers,
        shopId: toAllUsers ? null : shopId,
        title,
        message,
        scheduledDate
      },
      { Authorization: `Bearer ${idToken}` }
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in pushNotification: ${err}`);
  }
}
export const deleteNotification = async (pushNotificationId, isAllUsers) => {
  const { companyId, shopId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendDeleteRequest(
    `/api/${companyId}/push-notifications/${pushNotificationId}`,
    { shopId: isAllUsers ? null : shopId },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
